// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WxFVY","left":"styles_left__2GM7h"};